import { Maybe } from '@/graphql/gql/graphql';

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  if (value === null || value === undefined) return false;
  return true;
}

export function filterEmpty<T>(list:Maybe<T>[]) {
  return list.reduce((prev:T[], next:Maybe<T>) => {
    if (notEmpty(next)) {
      return [...prev, next];
    }
    return prev;
  }, [] as T[]);
}

export default {};
